<div>
  <div class="flex justify-between gap-4">
    <div class="grow">
      <div
        class="layout-margin flex flex-col items-stretch gap-4"
        cdkDropList
        [cdkDropListData]="multiTreatmentConfig.steps"
        (cdkDropListDropped)="dropStep($event)"
      >
        @for (
          treatmentStep of multiTreatmentConfig.steps;
          track treatmentStep.uid
        ) {
          <div
            class="drag-container flex-1"
            cdkDrag
            [cdkDragData]="treatmentStep"
          >
            <div class="treatment-step-title flex items-center justify-between">
              <div class="flex flex-1 items-center gap-2">
                <mat-icon class="cursor-grab text-gray-400" cdkDragHandle
                  >drag_indicator</mat-icon
                >
                <h2 class="m-0">{{ treatmentStep.name }}</h2>
              </div>

              <button
                mat-icon-button
                ptIntercomTarget="treatment-steps.menu-button"
                [matMenuTriggerFor]="treatmentStepMenu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #treatmentStepMenu="matMenu">
                <ng-template matMenuContent>
                  <button
                    mat-menu-item
                    ptIntercomTarget="treatment-steps.edit-button"
                    (click)="editTreatmentStep(treatmentStep)"
                  >
                    <mat-icon>edit</mat-icon>
                    Edit
                  </button>
                  <button
                    mat-menu-item
                    color="warn"
                    ptIntercomTarget="treatment-steps.delete-button"
                    (click)="removeTreatmentStep(treatmentStep)"
                  >
                    <mat-icon>delete</mat-icon>
                    Delete
                  </button>
                </ng-template>
              </mat-menu>
            </div>

            <pr-relative-scheduling-summary
              *ngIf="treatmentStep.schedulingRules"
              [rules]="treatmentStep.schedulingRules"
            />

            <div
              class="treatment-list"
              cdkDropList
              [id]="getStepListId(treatmentStep.uid)"
              [cdkDropListConnectedTo]="connectedDropLists"
              [cdkDropListData]="treatmentStep.treatments"
              (cdkDropListDropped)="drop($event)"
            >
              @for (
                treatment of treatmentStep.treatments;
                track treatment.ref.path
              ) {
                <div
                  class="treatment-box flex items-center justify-between"
                  cdkDrag
                  cdkScrollable
                  [cdkDragData]="treatment"
                >
                  <span>{{ treatment.name }}</span>
                  <div class="flex items-center">
                    <pr-increase-decrease-input
                      [decreaseDisabled]="treatment.quantity < 1"
                      (increase)="increaseQuantity(treatment)"
                      (decrease)="decreaseQuantity(treatment, treatmentStep)"
                      (mousedown)="$event.stopImmediatePropagation()"
                    >
                      <label>Qty</label>
                      {{ treatment.quantity }}
                    </pr-increase-decrease-input>
                  </div>
                </div>
              }
            </div>

            <div *cdkDragPlaceholder class="step-placeholder"></div>
          </div>
        }

        <button mat-flat-button color="primary" (click)="addTreatmentStep()">
          <mat-icon aria-label="Remove from list">add</mat-icon>
          Add New Treatment Step
        </button>
      </div>
    </div>

    <div class="grow">
      <h2>Available Treatments</h2>

      <pt-search-field
        class="layout-margin"
        ptIntercomTarget="treatment-steps.search-input"
      >
        <input
          #search
          matInput
          placeholder="Search"
          [formControl]="searchCtrl"
        />
      </pt-search-field>

      <div
        class="treatment-list layout-margin"
        cdkDropList
        [id]="treatmentOptionsId"
        [cdkDropListConnectedTo]="connectedDropLists"
        [cdkDropListData]="treatmentOptions$ | async"
        [cdkDropListEnterPredicate]="noReturnPredicate"
        (cdkDropListDropped)="drop($event)"
      >
        @for (
          treatment of treatmentOptions$ | async;
          track treatment.ref.path
        ) {
          <div
            class="treatment-box treatment-option flex items-center justify-between"
            cdkDrag
            cdkScrollable
            [cdkDragData]="treatment"
          >
            <span>{{ treatment.name }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<pt-buttons-container padding="all-round">
  <button type="submit" mat-flat-button color="primary" (click)="save()">
    Save
  </button>
</pt-buttons-container>
